import React from 'react';
import BaseComponent from './BaseComponent';

class ProjectView extends BaseComponent {
    constructor(props) {
        super(props);

        this.handleLoad = this.handleLoad.bind(this);
    }

    handleLoad() {
        const { checkScript, params = {} } = this.props;
        const { contentWindow = {} } = this.projectView;
        const { Entry = {} } = contentWindow;
        const { checkMessage, checkTitle } = params;
        if (checkScript && Entry.container) {
            Entry.container.addExtension(
                new Entry.TargetChecker(
                    checkScript,
                    false,
                    entrylms.getData().type + '_intro'
                )
            );
            Entry.targetChecker.generateStatusView(true);
        }
        contentWindow.document.body.className = '';
    }

    render() {
        const lmsData = entrylms.getData() || {};
        const { projectIframeLink = '/api/iframe/project' } = lmsData;
        const params = {
            play: 'true',
            hideplaybtn: true,
            ...this.props.params,
        };
        return (
            <iframe
                src={`${projectIframeLink}/${this.props.content}?${Object.keys(
                    params
                )
                    .map((key) => key + '=' + params[key])
                    .join('&')}`}
                ref={(dom) => {
                    this.projectView = dom;
                }}
                onLoad={this.handleLoad}
            />
        );
    }
}

ProjectView.displayName = 'ProjectView';
ProjectView.propTypes = {};

export default ProjectView;



// WEBPACK FOOTER //
// ./components/CommonSet/ProjectView.js